import styled from 'styled-components';
import * as shared from '~/shared';
import FancyRadio from '~/shared/FancyRadio';
import AlertBox from '~/shared/AlertBox';

export const TextInputContainer = styled.div`
    margin-bottom: 20px;
    text-align: left;
`;

export const TextInputLabel = styled.div`
    color: #303030;
    padding-bottom: 5px;
`;

export const StyledFancyRadio = styled(FancyRadio)`
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: min(4vw, 16px);
`;

export const StyledAlertBox = styled(AlertBox)`
    margin-top: 15px;
`;

export const TextInput = styled(shared.TextInput)`
    width: 100%;
    font-size: 16px;
`;

export const Image = styled.img`
    width: 30%;
`;

export const Container = shared.Container;
export const CenterScreenContainer = shared.CenterScreenContainer;
export const Button = shared.Button;
export const Header = shared.Header;
export const StyledLink = shared.StyledLink;
